(function () {
    'use strict';

    angular.module('thankview.pricing')
        .factory('pricingService', ['$rootScope', '$timeout', '$q', 'ajax', 'dates', function ($rootScope, $timeout, $q, ajax, dates) {
            var payments = {};

            function formatPackgeInfo(data) {
                // format dates and months for the upcoming payment
                data.payment.due_date = dates.convert(data.payment.due_date);
                data.payment.months = data.package.months;
                data.payment.is_monthly = data.package.is_monthly;

                // set the payment start and end date based on the package or the current date
                if (data.package.subscription_start_date) {
                    data.payment.start_date = dates.convert(data.package.subscription_start_date);
                    data.payment.end_date = dates.convert(data.package.subscription_end_date);
                } else {
                    var startDate = data.payment.due_date ? new Date(data.payment.due_date.valueOf()) : new Date();
                    data.payment.start_date = new Date(startDate.valueOf());
                    data.payment.end_date = new Date(startDate.setMonth(startDate.getMonth() + data.payment.months));
                }

                if (!data.payment.is_upsell) {
                    // use the complete package details to display to the user instead of the individual payment
                    angular.forEach(data.package.details, function (detail, i) {
                        data.payment[i] = detail;
                    });

                    // show the annual credits and sms if the subscription is longer than a year
                    if (data.payment.months > 12) {
                        // data.payment.sends_credited *= 12 / data.payment.months;
                        // data.payment.sms_credited *= 12 / data.payment.months;
                        data.payment.name = data.package.name + ' - ' + data.payment.name;
                    } else data.payment.name = data.package.name;
                }

                return data;
            }

            payments.fetchConsumer = function () {
                var deferred = $q.defer();

                ajax.get('/api/pricing').then(function (data) {
                    angular.forEach(data.pricing, function (option) {
                        var cost = option.cost / 100;
                        option.costDisplay = '$' + cost + (cost <= 200 ? '.00' : '');
                    });

                    deferred.resolve(data);
                }).catch(function () {
                    deferred.reject();
                });

                return deferred.promise;
            };

            payments.fetchBusiness = function (slug) {
                var deferred = $q.defer();

                ajax.get('/api/pricing/business', { slug: slug }).then(function (data) {
                    if (data.payment) {
                        data = formatPackgeInfo(data);
                    }
                    // return upcoming payment, upsells, and if paywall is active
                    deferred.resolve({
                        suspended: data.suspended,
                        suspended_reason: data.suspended_reason,
                        package: data.package,
                        payment: data.payment,
                        paymentUpsells: data.upsells,
                        isPaywallActive: data.isPaywallActive,
                        freeTrialExpired: data.freeTrialExpired,
                    });
                }).catch(function () {
                    deferred.reject();
                });

                return deferred.promise;
            };

            payments.fetchPayment = function (id) {
                var deferred = $q.defer();

                ajax.get('/api/package/payment/' + id).then((data) => {
                    if (data.payment) {
                        data = formatPackgeInfo(data);
                        deferred.resolve({
                            package: data.package,
                            payment: data.payment,
                        });
                    } else if (data.is_paid) {
                        deferred.resolve({
                            paid: true,
                        });
                    }
                }).catch(() => {
                    deferred.reject();
                });

                return deferred.promise;
            };

            payments.fetchBusinessLogin = function (slug) {
                var deferred = $q.defer();

                ajax.get('/api/pricing/business', { slug: slug, minimal: true }).then(function (data) {
                    try {
                        const decrypted = atob(data.d);
                        const payload = JSON.parse(decrypted);

                        const packageStatusMap = { 0: 'none', 1: 'active', 2: 'upcoming' };

                        deferred.resolve({
                            suspended: payload.s === 1,
                            suspended_reason: payload.r,
                            isPaywallActive: payload.p === 1,
                            freeTrialExpired: payload.t === 1,
                            packageStatus: packageStatusMap[payload.k] || 'none',
                        });
                    } catch (error) {
                        console.error('Failed to decrypt login data:', error);
                        deferred.reject();
                    }
                }).catch(function () {
                    deferred.reject();
                });

                return deferred.promise;
            };

            return payments;
        }]);
}());
